import BotaoText from "@/components/BotaoText";
import IconBoleto from "@/components/icons/IconBoleto";
import IconCar from "@/components/icons/IconCar";
import IconPix from "@/components/icons/IconPix";
import { getPrimaryColorButton } from "@/services/whitelabel";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid2";
import { useSelector } from "react-redux";
import "./BotoesInicioSimulacao.scss";

export default function BotoesInicioSimulacao({ iniciaSimulacao, voltar }) {
  const user = useSelector((state) => state.user);
  const colorText = user.isQuitaboletos ? "#145401" : "white";
  return (
    <Container component="main" maxWidth="xs">
      <Grid container spacing={1} align="center">
        <Grid size={12}>
          <button
            className="botao-escolha-tipo-pagamento"
            id="btn-escolha-boleto"
            style={{
              color: colorText,
              backgroundColor: user.isQuitaboletos
                ? "#fdcf2f"
                : getPrimaryColorButton(user),
            }}
            onClick={() => {
              iniciaSimulacao("boleto");
            }}>
            <IconBoleto
              style={{
                color: colorText,
              }}></IconBoleto>

            <div className="texto">
              <div className="titulo">Boleto</div>
              <div className="descricao">Água, luz, contas diversas, etc</div>
            </div>
          </button>
        </Grid>
        <Grid size={12}>
          <button
            className="botao-escolha-tipo-pagamento"
            id="btn-escolha-pix"
            style={{
              color: colorText,
              backgroundColor: user.isQuitaboletos
                ? "#d8ff57"
                : getPrimaryColorButton(user),
            }}
            onClick={() => {
              iniciaSimulacao("PIX");
            }}>
            <IconPix
              style={{
                color: colorText,
              }}></IconPix>

            <div className="texto">
              <div className="titulo">Chave PIX</div>
              <div className="descricao">CPF, CNPJ, telefone, e-mail, etc</div>
            </div>
          </button>
        </Grid>
        <Grid size={12}>
          <button
            className="botao-escolha-tipo-pagamento"
            id="btn-escolha-ipva"
            style={{
              color: colorText,
              backgroundColor: user.isQuitaboletos
                ? "#ffb3d2"
                : getPrimaryColorButton(user),
            }}
            onClick={() => {
              iniciaSimulacao("IPVA");
            }}>
            <IconCar
              style={{
                color: colorText,
              }}></IconCar>

            <div className="texto">
              <div className="titulo">IPVA e licenciamento</div>
              <div className="descricao">Pague seus tributos conosco</div>
            </div>
          </button>
        </Grid>
        <Grid size={12}>
          <BotaoText onClick={voltar}>VOLTAR</BotaoText>
        </Grid>
      </Grid>
    </Container>
  );
}
